import React, { useEffect, useState } from 'react';

import FileNavigator from '../ncFileManager/fileManager/client/components/FileNavigator/FileNavigator.react';

import sendFilesConnector from '../ncFileManager/send-files-connector';

import { apiOptions } from '../../shared/constants/apiOptions';

const SendFilesNavigator = ({ rootContainer, selectFilesToSend, permissions, controlConfiguration, ownerTypeOverride }) => {
  const [api, setApi] = useState(null);

  useEffect(() => {
    if (window['ncFileManager']) {
      window['ncFileManager']['ownerTypeOverride'] = ownerTypeOverride;
    }

    setApi(sendFilesConnector.api);
  }, []);

  const navigator = api ? (
    <FileNavigator
      id="filemanager-2"
      rootContainer={rootContainer}
      api={api}
      apiOptions={{ ...apiOptions, ...sendFilesConnector.apiOptions }}
      capabilities={sendFilesConnector.capabilities}
      listViewLayout={sendFilesConnector.listViewLayout}
      viewLayoutOptions={sendFilesConnector.viewLayoutOptions}
      disableToolbar={false}
      permissions={permissions}
      controlConfiguration={controlConfiguration}
      isSendFiles={true}
      isOnCertsPage={window['ncFileManager']['isOnCertsPage']}
      onSelectFilesToSend={selectFilesToSend}
    ></FileNavigator>
  ) : null;

  return navigator;
};

export default SendFilesNavigator;
